import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import { ElderTabGroupRoutingDirective } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { FacilityContextService } from '../../../context/facility-context/facility-context.service'
import { ControlCenterType } from '../control-center'
import { ControlCenterBrowserComponent } from '../control-center-browser/control-center-browser.component'

@Component({
  selector: 'app-control-center-viewer',
  templateUrl: './control-center-viewer.component.html',
  styleUrls: ['./control-center-viewer.component.scss'],
  imports: [
    MatTabGroup,
    ElderTabGroupRoutingDirective,
    MatTab,
    MatTabLabel,
    ControlCenterBrowserComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ControlCenterViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  readonly types = Object.values(ControlCenterType)
  readonly facility$: Observable<string>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const facilityContextService = inject(FacilityContextService)

    this.facility$ = facilityContextService.facility$.pipe(map((facility) => facility.id))
  }
}
